import script from "./IframeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./IframeItem.vue?vue&type=script&setup=true&lang=js"

import "./IframeItem.vue?vue&type=style&index=0&id=69d64a3e&lang=scss"

const __exports__ = script;

export default __exports__